import { NumberTextFieldDE } from "../common/NumberTextFieldDE";

export type NumberFields<T> = {
  [K in keyof T]: T[K] extends number | null ? K : never;
}[keyof T];

type ProcessDataNumberTextFieldProps<T> = {
  value: number | undefined | null;
  field: NumberFields<T>;
  label?: string;
  disabled?: boolean;
  onChange?: (value: number) => void;
  onBlur?: () => void;
  onFocus?: () => void;
};

export const ProcessDataNumberTextField = <T,>({
  value,
  field,
  label,
  disabled,
  onChange = () => {},
  onBlur = () => {},
  onFocus = () => {},
}: ProcessDataNumberTextFieldProps<T>) => {
  return (
    <NumberTextFieldDE
      disabled={disabled}
      label={label || String(field)}
      value={value || null}
      onChange={onChange}
      onBlur={onBlur}
      onFocus={onFocus}
    />
  );
};
